export default "/dist/files/aucune_animation.528658a3fdc48a4fc348e7440f4ea91b.svg";